'use client'

import { ReactNode } from 'react'
import BaseLayoutTemplate from './BaseLayoutTemplate'

interface ShortLayoutTemplateProps {
  children: ReactNode
  brand?: any
  globalData?: any
  loginEl?: any
  setLoginEl?: any
  headerMenuJson?: any
  footerJson?: any
  pageInserts?: any
  env?: string
}

/**
 * Short Layout Template - For pages that need a short header and no footer
 * Used for: Style quiz, room quiz, recommendations, builder, cart, upload instructions
 */
export default function ShortLayoutTemplate(props: ShortLayoutTemplateProps) {
  return (
    <div data-layout-type="short">
      <BaseLayoutTemplate {...props} />
    </div>
  )
}